export const minTeamTableColumnsWidth = {
  edit: 120,
  userRole: 340,
};
